import React from 'react';
import { Link } from 'react-router-dom';
import { useLang } from '@/i18n/LanguageContext';
import { useAuth } from '@/auth/AuthContext';
import PageDetailsAccordion from '@/components/PageDetailsAccordion';
import { EditorialPage, EditorialSection, EditorialCards, EditorialLinks } from '@/components/Editorial';

const textLink = 'text-[#557448] underline underline-offset-4 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4';

export default function ForFarmers() {
  const { t } = useLang();
  const { user, isChecking } = useAuth();
  const present = { to: '/list-your-farm', label: t('farmersPage.present') };
  const atlas = { to: '/atlas?subject_type=farm,livestock,nursery', label: t('profilePathCommon.atlas') };
  return <EditorialPage testId="for-farmers-page" title={t('farmersPage.title')} intro={t('farmersPage.intro')}>
    <EditorialLinks links={[present, atlas]} />
    <p className="mt-3 text-sm text-[#6E6258]">{t('profilePathCommon.accountNote')}</p>
    <EditorialSection title={t('farmersPage.cardsTitle')}>
      <EditorialCards symbols={['territory', 'crops', 'livestock', 'story']} items={t('farmersPage.cards')} />
      <p className="mt-4 text-sm text-[#6E6258]">{t('farmersPage.optionalNote')}</p>
    </EditorialSection>
    <EditorialSection title={t('farmersPage.opportunitiesTitle')}>
      <p className="text-[#4A443D] leading-relaxed">{t('farmersPage.opportunities')}</p>
      <p className="mt-3 text-sm text-[#6E6258]">{t('profilePathCommon.activityNote')}</p>
      <div className="flex flex-wrap gap-x-5 gap-y-2 mt-4 text-sm">
        <Link className={textLink} to="/how-it-works">{t('profilePathCommon.formulas')}</Link>
        <Link className={textLink} to="/plans">{t('profilePathCommon.planFeatures')}</Link>
      </div>
    </EditorialSection>
    <EditorialSection title={t('farmersPage.detailsTitle')}>
      <PageDetailsAccordion panels={t('farmersPage.details').map((panel, index) => ({
        id: ['farmer-crops-areas', 'farmer-livestock-profile'][index], title: panel.title,
        children: <>{panel.paragraphs.map(paragraph => <p key={paragraph}>{paragraph}</p>)}</>,
      }))} />
    </EditorialSection>
    <EditorialSection title={t('profilePathCommon.plansTitle')}>
      <p className="text-[#4A443D] leading-relaxed">{t('profilePathCommon.plansSummary')}</p>
      <div className="flex flex-wrap gap-x-5 gap-y-2 mt-4 text-sm">
        <Link className={textLink} to="/plans">{t('profilePathCommon.comparePlans')}</Link>
        <Link className={textLink} to="/plans#pro-payments-fees">{t('profilePathCommon.fees')}</Link>
      </div>
    </EditorialSection>
    <aside className="mt-8 rounded-md border border-[#E2DACB] bg-[#EAF0E6] p-4 text-sm text-[#4A443D]" data-testid="profile-representation-note">{t('profilePathCommon.representation')}</aside>
    <EditorialSection title={t('profilePathCommon.startTitle')}>
      <EditorialLinks links={[present, { to: '/faq', label: t('profilePathCommon.faq') }]} />
      {user && !isChecking && <p className="mt-4 text-sm"><Link className={textLink} to="/dashboard">{t('profilePathCommon.manageProfiles')}</Link></p>}
    </EditorialSection>
  </EditorialPage>;
}
